<template>
  <div class="h5-workplace">
    <!-- 顶部导航栏 -->
    <div class="header">
      <h1>工作台</h1>
    </div>
    
    <!-- 功能入口区域 -->
    <div class="function-list">
          <!-- 发放设备入口 -->
      <div class="function-item" @click="navigateToUserDetail">
        <div class="function-icon device-icon">
          <el-icon class="icon"><Monitor /></el-icon>
        </div>
        <div class="function-name">设备查询</div>
      </div>

      <!-- 发放设备入口 -->
      <div class="function-item" @click="navigateToIssueDevice">
        <div class="function-icon device-icon">
          <el-icon class="icon"><Monitor /></el-icon>
        </div>
        <div class="function-name">发放设备</div>
      </div>

      <!-- 生成兑换码入口 -->
      <div class="function-item" @click="navigateToExchangeCode">
        <div class="function-icon exchange-icon">
          <el-icon class="icon"><Trophy /></el-icon>
        </div>
        <div class="function-name">生成兑换码</div>
      </div>

      <!-- 分配规格设备入口 -->
      <div class="function-item" @click="navigateToAllocateDevice">
        <div class="function-icon allocate-icon">
          <el-icon class="icon"><Setting /></el-icon>
        </div>
        <div class="function-name">分配规格设备</div>
      </div>

         <!-- 设置库存 -->
      <div class="function-item" @click="navigateToSkuInventory">
        <div class="function-icon allocate-icon">
          <el-icon class="icon"><Setting /></el-icon>
        </div>
        <div class="function-name">设置库存</div>
      </div>

      <!-- 回到主页入口 -->
      <div class="function-item" @click="navigateToHome">
        <div class="function-icon home-icon">
          <el-icon class="icon"><Goods /></el-icon>
        </div>
        <div class="function-name">回到主页</div>
      </div>
    </div>

    <!-- 底部信息 -->
    <div class="footer">
      <p>MatrixTech 管理系统</p>
      <p class="version">版本 1.0.0</p>
    </div>
  </div>
</template>

<script setup>
import { ElIcon } from "element-plus";
import { Monitor, Goods, Trophy, Setting, SwitchButton } from "@element-plus/icons-vue";

// 跳转到设备查询页面
const navigateToUserDetail = () => {
  window.location.href = '/h5/userDetail';
};

// 跳转到发放设备页面
const navigateToIssueDevice = () => {
  // 这里可以根据实际路由配置进行跳转
  // 例如：router.push('/h5/getDevice')
  window.location.href = '/h5/getDevice';
};

// 跳转到设置SKU库存页面
const navigateToSkuInventory = () => {
  // 这里可以根据实际路由配置进行跳转
  // 例如：router.push('/h5/skuInventory')
  window.location.href = '/h5/configSkuStock';
};

// 跳转到生成兑换码页面
const navigateToExchangeCode = () => {
  // 这里可以根据实际路由配置进行跳转
  // 例如：router.push('/h5/exchangeCode')
  window.location.href = '/h5/exchangeCode';
};

// 跳转到分配规格设备页面
const navigateToAllocateDevice = () => {
  // 这里可以根据实际路由配置进行跳转
  // 例如：router.push('/h5/allocateDevice')
  window.location.href = '/h5/allocateDevice';
};

// 回到主页
const navigateToHome = () => {
  window.location.href = '/';
};


</script>

<style scoped>
.h5-workplace {
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.header {
  background-color: #409eff;
  color: white;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.function-list {
  flex: 1;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.function-item {
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
}

.function-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.function-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-icon {
  background-color: #ecf5ff;
}

.exchange-icon {
  background-color: #fffbe6;
}

.sku-icon {
  background-color: #f0f9eb;
}

.allocate-icon {
  background-color: #f0f0f0;
}

.home-icon {
  background-color: #e6f7ff;
}

.tenant-icon {
  background-color: #f6ffed;
}

.icon {
  font-size: 24px;
  color: #409eff;
}

.tenant-icon .icon {
  color: #67c23a;
}

.function-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.footer {
  padding: 16px;
  text-align: center;
  background-color: white;
  border-top: 1px solid #e4e7ed;
}

.footer p {
  margin: 4px 0;
  font-size: 12px;
  color: #909399;
}

.footer .version {
  font-size: 10px;
}

/* 适配移动端样式 */
@media (max-width: 768px) {
  .function-list {
    padding: 24px 12px;
  }
  
  .function-item {
    padding: 20px;
  }
  
  .function-icon {
    width: 48px;
    height: 48px;
  }
  
  .icon {
    font-size: 20px;
  }
  
  .function-name {
    font-size: 15px;
  }
}
</style>